import type { SVGProps } from 'react';

const SvgCropDin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M21 3H3v18h18zm-2 16H5V5h14z" />
  </svg>
);
export default SvgCropDin;
